import dayjs from 'dayjs';
import React from 'react';
import { Box, Chip, Stack, Typography } from '@mui/material';
import { IVisibleStation } from '../../dto/StationVisibility.dto';
import { IFacilityShareWindowDraft } from '../../dto/FacilitySharing.dto';

interface FacilitySharePreviewProps {
  selectedStationIds: number[];
  facilityStations: IVisibleStation[];
  targetWindows: Record<number, IFacilityShareWindowDraft>;
}

const FacilitySharePreview: React.FC<FacilitySharePreviewProps> = ({
  selectedStationIds,
  facilityStations,
  targetWindows,
}) => {
  if (selectedStationIds.length === 0) {
    return null;
  }

  const stationsById = new Map(
    facilityStations.map(station => [station.id, station] as const),
  );

  return (
    <Box
      sx={{
        mt: 3,
        p: 2,
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 2,
        backgroundColor: 'background.paper',
      }}>
      <Typography variant='subtitle2' sx={{mb: 1.5, fontWeight: 600}}>
        Share Preview
      </Typography>
      <Stack spacing={1.5}>
        {selectedStationIds.map(stationId => {
          const station = stationsById.get(stationId);
          const targetWindow = targetWindows[stationId];

          return (
            <Box
              key={stationId}
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                gap: 2,
                flexWrap: 'wrap',
              }}>
              <Box>
                <Typography variant='body2' fontWeight={600}>
                  {station?.name || `Station #${stationId}`}
                </Typography>
                <Typography variant='caption' color='text.secondary'>
                  {station?.owner_company_name || 'Visible shared facility'}
                </Typography>
              </Box>
              {targetWindow?.starts_at && targetWindow?.ends_at ? (
                <Chip
                  size='small'
                  color='info'
                  variant='outlined'
                  label={`${dayjs(targetWindow.starts_at).format(
                    'MMM D, h:mm A',
                  )} → ${dayjs(targetWindow.ends_at).format('MMM D, h:mm A')}`}
                />
              ) : null}
            </Box>
          );
        })}
      </Stack>
    </Box>
  );
};

export default FacilitySharePreview;